import { Grid, styled } from '@mui/material';
import { Card, Typography } from '@totalsoft/rocket-ui';
import FlexBox from 'components/common/FlexBox';

export const DashboardCard = styled(Card)(() => ({
  height: '150px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between'
}));

export const DashboardCardTitle = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  whiteSpace: 'pre-wrap',
  '-webkit-line-clamp': '2',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical'
}));

export const MainSearchContainer = styled(Grid)(() => ({
  minHeight: '55px'
}));

export const HeaderSearchContainer = styled(FlexBox)(({ theme }) => ({
  [theme.breakpoints.between('sm', 'lg')]: {
    marginLeft: theme.spacing(1)
  },
  [theme.breakpoints.up('lg')]: {
    marginLeft: theme.spacing(3)
  },
  [theme.breakpoints.up('xl')]: {
    marginLeft: theme.spacing(9)
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%'
  },
  width: 'max(40vw, 250px)',
  '& > div': {
    width: '100%'
  }
}));
